export const name = 'assetsManagementsController';
export default function assetsManagementsController(assetsLibService, $log, $mdDialog, closeDialogFromOutsideHelperFactory, pusherChannel, listManagementFactory) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;

}
